import { Fragment } from 'react';

interface InlineCodeTextProps {
  children: string;
}

/** Code spans in short level text, without adding paragraphs or parsing HTML. */
export function InlineCodeText({ children }: InlineCodeTextProps) {
  const parts = [];
  const spans = /(?<!`)(`+)(?!`)([\s\S]*?)(?<!`)\1(?!`)/g;
  let start = 0;
  for (const match of children.matchAll(spans)) {
    parts.push(children.slice(start, match.index));
    parts.push(
      <code key={match.index} className="break-words rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.875em] text-inherit dark:bg-gray-700">
        {match[2]}
      </code>,
    );
    start = match.index! + match[0].length;
  }
  parts.push(children.slice(start));
  return <Fragment>{parts}</Fragment>;
}
